import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home.vue";
import SearchPage from "@/views/SearchPage";
import SearchResult from "@/views/SearchResult";
import BioDetail from "@/views/BioDetail";
import CommunityDetail from "@/views/CommunityDetail";
import Login from "@/views/Login";
import Report from "@/views/Report";
import Survey from "@/views/Survey";
import Result from "@/views/Result";
import form from "@/views/form";
import plantInfo from "@/views/plantInfo";
import saveBank from "@/views/SaveBank";
import CommunityEdit from "@/views/CommunityEdit";
import ForgetPassword from "@/views/ForgetPassword";
import ResetPassword from "@/views/ResetPassword";
import PDPA from "@/views/PDPA";
import Document from "@/views/Documents";
import Documents from "@/views/DocumentMain";

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/Login",
    name: "Login",
    component: Login,
  },
  {
    path: "/Search",
    name: "Search",
    component: SearchPage,
  },
  {
    path: "/SearchResult",
    name: "SearchResult",
    component: SearchResult,
  },
  {
    path: "/BioDetai/:id",
    name: "BioDetai",
    component: BioDetail,
  },
  {
    path: "/document/:id",
    name: "document",
    component: Document,
  },
  {
    path: "/documents",
    name: "documents",
    component: Documents,
  },
  {
    path: "/CommunityDetail/:id",
    name: "CommunityDetail",
    component: CommunityDetail,
  },
  {
    path: "/Report",
    name: "Report",
    component: Report,
  },
  {
    path: "/Survey",
    name: "Survey",
    component: Survey,
  },
  {
    path: "/Result",
    name: "Result",
    component: Result,
  },
  {
    path: "/form",
    name: "form",
    component: form,
  },
  {
    path: "/plantInfo",
    name: "plantInfo",
    component: plantInfo,
  },
  {
    path: "/saveBank",
    name: "saveBank",
    component: saveBank,
  },
  {
    path: "/communityEdit",
    name: "CommunityEdit",
    component: CommunityEdit,
  },
  {
    path: "/forgetPassword",
    name: "forgetPassword",
    component: ForgetPassword,
  },
  {
    path: "/resetPassword",
    name: "resetPassword",
    component: ResetPassword,
  },
  {
    path: "/pdpa",
    name: "pdpa",
    component: PDPA,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
